module.exports = __webpack_public_path__ + "static/amarok-highline-eb61098e6d7fdbaa244233ee8f9a613b.png";